import {Table } from 'antd'
import React, { useEffect, useState } from 'react'
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './expense.module.css';
import StateTag from '../../cpn/StateTag';
import ExpenseEdit from './ExpenseEdit';
function ExpenseListPendding(props) {
    const [list,setList] = useState([]);   
    useEffect(() => {
        if (props.list) {
            let arr = props.list.filter((item) => item.fy_state === '1' && item.fy_uid === props.yh_id);           
            arr.sort((a, b) => new Date(b.fy_ctime) - new Date(a.fy_ctime));
             // Ensure each item has a unique key property
             arr = arr.map((item) => ({
                ...item,
                key: item.key || item.ddsr_id
            }));
            setList(arr);
        }
    }, [props.list, props.yh_id])
    
    const columns = [    
        {
            title: '费用客户',
            dataIndex: 'fy_kh_name',
            width: '12%',
            key: 'fy_kh_name',         
            render: (text, record) => <ExpenseEdit 
                                        fy_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        fy_bzd_id={record.fy_bzd_id}
                                        fy_price={record.fy_price}
                                        fy_content={record.fy_content}
                                        fy_date={record.fy_date}
                                        fy_date_end={record.fy_date_end}
                                        fy_bzd_name={record.fy_bzd_name}
                                        fy_bzd_danhao={record.fy_bzd_danhao}
                                        fy_type_id={record.fy_type_id}
                                        fy_type_name={record.fy_type_name}
                                        fy_kh_id={record.fy_kh_id}
                                        fy_kh_name={record.fy_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        fy_num={record.fy_num}
                                        fy_amount={record.fy_amount}
                                        fy_state={record.fy_state}
                                        fy_bm_id={record.fy_bm_id}
                                        fy_bm_name={record.fy_bm_name}
                                        fy_khyhzh_id={record.fy_khyhzh_id}
                                        fy_khyhzh_name={record.fy_khyhzh_name}
                                        fy_image_name={record.fy_image_name}
                                        fy_image_file={record.fy_image_file}
                                        fy_ctime={record.fy_ctime}
                                    />
        },
        {
            title: '费用金额',
            dataIndex: 'fy_amount',
            width: '10%',
            key: 'fy_amount',   
            render: (text, record) => <span style={{color:'#3366cc'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '备注',
            dataIndex: 'fy_content',
            key:'fy_content',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            dataIndex: 'fy_bzd_name',
            key:'fy_bzd_name',
            render:(text,record) => <ReportCheck dsbzd_name={record.fy_bzd_name} dsbzd_id={record.fy_bzd_id} dsbzd_danhao={record.fy_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
        },       
        {
            title: '状态',
            dataIndex: 'fy_state',
            width: '5%',
            key: 'fy_state',            
            render:(text) => <StateTag state={text} />
        },
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },
        
    ]
    return (
        <>                            
            {/* <Flex style={{ marginBottom: "10px" }} justify='space-between' align='center'>
                <Form 
                    name='income' 
                    layout='inline' 
                    form={form}
                    onFinish={(values) => {
                        console.log(values,'values');
                        setQuery(prev => ({
                            ...prev, 
                            fy_content: values.fy_content ? values.fy_content : '', 
                            fy_kh_id: values.fy_kh_id ? values.fy_kh_id : '',
                            fy_bzd_danhao: values.fy_bzd_danhao ? values.fy_bzd_danhao : '',
                        }))
                    }}
                    initialValues={{
                        fy_content:'',
                        fy_kh_id:'',
                        fy_bzd_danhao:'',
                    }}
                >
                    <Form.Item name='fy_kh_id'>
                        <ClientSelect
                            wrapperCol={null}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            style={{width:'150px'}}
                            onChange={() => {}}
                        />
                    </Form.Item>
                    <Form.Item name='fy_bzd_danhao'>
                        <Input 
                            placeholder='团队编号' 
                           
                        />
                    </Form.Item>                    
                    <Form.Item name='fy_content'>
                        <Input 
                            placeholder='备注关键字' 
                           
                        />
                    </Form.Item>                    
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon 
                                type='reset' 
                                onClick={() => {
                                    form.resetFields()
                                    setQuery({
                                        fy_content:''
                                    })
                                }}
                            />                          
                        </Space>
                    </Form.Item>
                </Form>
            </Flex> */}
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.fy_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={1}>
                                <span style={{color:'#3366cc'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无费用单数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default ExpenseListPendding